import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from '../../../../environments/environment';
import IHttpResponse from '../../interfaces/shared/IHttpResponse';
import { ICotizacion } from '../../interfaces/bundle/ICotizacion';
import { APP_BASE_HREF } from '@angular/common';



@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  url = "";

  constructor(private http: HttpClient, @Inject(APP_BASE_HREF) private baseHref: string) {
    this.url = baseHref + environment.apis.pricing;
  }

  getCotizacionByIdProducto(idProducto: string, productName: string): Observable<any> {
    return this.http.get<any>(`${this.url}/GetQuotation/${idProducto}/${productName}`);
  }

  // quotation(body: any): Observable<any>{
  //   return this.http.post<IHttpResponse<ICotizacion>>(`${this.url}/Quotation/}`, body)
  // }


  // quotation(body: any): Observable<IHttpResponse<ICotizacion>> {
  //   const mockResponse: IHttpResponse<ICotizacion> = {
  //     succeeded: true,
  //     errors: [],
  //     message: 'Cotización generada correctamente',
  //     data: {
  //       idCotizacion: 12345,
  //       descuento: 10,
  //       anual: 1200,
  //       mensual: 100
  //     }
  //   };

  //   return of(mockResponse);
  // }

}
